import { DELETE_ABOUT_US_ERROR, DELETE_ABOUT_US_START, DELETE_ABOUT_US_SUCCESS } from '../../types';

export default function delete_about_us(state, action) {
  switch (action.type) {
    case DELETE_ABOUT_US_START:
      return { ...state };
    case DELETE_ABOUT_US_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case DELETE_ABOUT_US_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
